export const reloadApp = () => {
  return window.location.reload();
};
